var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../Icons/Icon';
import capitalizeString from '../../util/capitalizeString';
import * as Styled from './Button.styled';
/**
 * Button component
 */
var Button = React.forwardRef(function (_a, ref) {
    var _b, _c;
    var _d = _a.isDisabled, isDisabled = _d === void 0 ? false : _d, _e = _a.isLoading, isLoading = _e === void 0 ? false : _e, _f = _a.isFull, isFull = _f === void 0 ? false : _f, _g = _a.colorMode, colorMode = _g === void 0 ? 'day' : _g, _h = _a.size, size = _h === void 0 ? 'regular' : _h, _j = _a.variant, variant = _j === void 0 ? 'default' : _j, _k = _a.isGhost, isGhost = _k === void 0 ? false : _k, _l = _a.iconLeft, iconLeft = _l === void 0 ? false : _l, _m = _a.iconRight, iconRight = _m === void 0 ? false : _m, _o = _a.state, state = _o === void 0 ? 'default' : _o, _p = _a.enabledPseudoclass, enabledPseudoclass = _p === void 0 ? true : _p, _q = _a.disableRadiusAnimation, disableRadiusAnimation = _q === void 0 ? false : _q, buttonProps = __rest(_a, ["isDisabled", "isLoading", "isFull", "colorMode", "size", "variant", "isGhost", "iconLeft", "iconRight", "state", "enabledPseudoclass", "disableRadiusAnimation"]);
    var capitalize = function () {
        if (buttonProps.children &&
            !React.isValidElement(buttonProps.children) &&
            typeof buttonProps.children === 'string') {
            return capitalizeString(buttonProps.children);
        }
        return buttonProps.children;
    };
    var renderSubcopy = function () {
        var _a;
        if (!((_a = buttonProps.subCopy) === null || _a === void 0 ? void 0 : _a.text))
            return null;
        return (React.createElement(Styled.SubCopy, { twoLines: buttonProps.subCopy.twoLines }, buttonProps.subCopy.text));
    };
    // Translate deprecated variants to new ones for backwards compatibility
    var translatedVariant = (function () {
        switch (variant) {
            case 'success':
            case 'defaultDark':
            case 'group':
                return 'default';
            case 'defaultLight':
            case 'link':
                return 'secondary';
            default:
                return variant;
        }
    })();
    // Translate deprecated sizes to new ones for backwards compatibility
    var translatedSize = (function () {
        switch (size) {
            case 'small':
                return 'mini';
            case 'medium':
                return 'regular';
            case 'large':
                return 'mega';
            case 'x-large':
                return 'x-mega';
            default:
                return size;
        }
    })();
    // Add ghost prop to old variants for backwards compatibility because defaultLight and 'defaultDark' are variants 'secondary' with ghost prop
    var translatedGhost = (function () {
        switch (variant) {
            case 'linkLight':
            case 'success':
            case 'group':
                return false;
            case 'defaultLight':
            case 'defaultDark':
            case 'link':
                return true;
            default:
                return isGhost;
        }
    })();
    return (React.createElement(Styled.Button, __assign({}, buttonProps, { enabledPseudoclass: enabledPseudoclass, disabled: isDisabled || isLoading || state === 'disabled' || state === 'loading', state: state, isLoading: isLoading, isFull: isFull, size: translatedSize, colorMode: colorMode, isGhost: translatedGhost, iconRight: iconRight, iconLeft: iconLeft, variant: translatedVariant, disableRadiusAnimation: disableRadiusAnimation, ref: ref, twoLines: (_b = buttonProps.subCopy) === null || _b === void 0 ? void 0 : _b.twoLines, subCopyText: (_c = buttonProps.subCopy) === null || _c === void 0 ? void 0 : _c.text }),
        iconLeft &&
            React.createElement(Icon, { "data-name": "icon-left", name: "chevron-left" }),
        !isLoading && capitalize(),
        !isLoading && renderSubcopy(),
        iconRight &&
            React.createElement(Icon, { "data-name": "icon-right", name: "chevron-right" })));
});
export default Button;
